import { type QueryFunctionContext, useInfiniteQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import type { IEquipmentsLogList, IUseEquipmentsLogListKeys } from '../model/equipmentsLogList';

export const equipmentsLogListKey = (keys?: IUseEquipmentsLogListKeys) => [
  'equipmentLogList',
  keys?.locationIds,
  keys?.search,
];

export const equipmentsLogListFn = ({
  queryKey,
  pageParam = 1,
}: QueryFunctionContext<ReturnType<typeof equipmentsLogListKey>, number>) => {
  const params = {
    locationIds: queryKey[1],
    page: pageParam,
    per_page: 20,
    search: queryKey[2] || undefined,
  };

  return apiClient
    .get(`${APP_API_URL}equipments/log-list`, { params })
    .then(({ data }: AxiosResponse<IEquipmentsLogList>) => {
      return data;
    });
};

export const useEquipmentsLogListInfiniteQuery = (keys: IUseEquipmentsLogListKeys) => {
  return useInfiniteQuery({
    queryKey: equipmentsLogListKey(keys),
    queryFn: equipmentsLogListFn,
    getNextPageParam: ({ pagination }) =>
      pagination.current_page < pagination.page_count ? pagination.current_page + 1 : undefined,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
};
